// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const slowking: PokeData = {
  "id": 199,
  "name": "slowking",
  "height": 20,
  "weight": 795,
  "base_experience": 172,
  "types": [
    PokeType.WATER,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "growl",
    "disable",
    "water-gun",
    "surf",
    "confusion",
    "psychic",
    "amnesia",
    "curse",
    "swagger",
    "hidden-power",
    "rain-dance",
    "psych-up",
    "yawn",
    "slack-off",
    "water-pulse",
    "trump-card",
    "power-gem",
    "nasty-plot",
    "zen-headbutt",
    "heal-pulse"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "growl",
    "psychic",
    "curse",
    "rain-dance",
    "zen-headbutt",
    "aqua-cutter",
    "aqua-tail",
    "psychic-fangs",
    "psywave",
    "life-dew",
    "liquidation"
  ],
  "evolution_chain": {
    "id": 33,
    "item": null,
    "species": [
      {
        "name": "slowpoke",
        "order": 85,
        "types": [
          PokeType.WATER,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "slowbro",
        "order": 86,
        "types": [
          PokeType.WATER,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 79,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "galarica-cuff"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "slowking",
        "order": 87,
        "types": [
          PokeType.WATER,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 79,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          },
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "galarica-wreath"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 169,
    "speed": 53,
    "ability_power": 178
  },
  "stat_changes": [],
  "catch_rate": 70,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
